import { IDocumentEntity } from '@phrospr/lib-models';
import {
    formatBytes,
    IAttachmentBudgetSummary,
    resolveMailDocuments,
    summarizeAttachmentBudget,
} from '@phrospr/lib-core';

export interface IQuoteAttachmentOverview {
    // Choosable in the picker: the always-attach documents go on every mail and are not a choice.
    selectable: IDocumentEntity[];
    alwaysIncluded: IDocumentEntity[];
    // Everything the mail will carry besides the quote PDF.
    onMail: IDocumentEntity[];
    budget: IAttachmentBudgetSummary | null;
}

export function quoteAttachmentOverview(
    selectedIds: number[],
    library: IDocumentEntity[],
    budgetBytes: number | null,
): IQuoteAttachmentOverview {
    const selected = library.filter(document => selectedIds.includes(document.document_id));
    const onMail = resolveMailDocuments(selected, library);
    return {
        selectable: library.filter(document => !document.always_attach),
        alwaysIncluded: library.filter(document => document.always_attach && document.active),
        onMail,
        budget:
            budgetBytes === null
                ? null
                : summarizeAttachmentBudget(
                      onMail.map(document => ({ name: document.file_name, size_bytes: document.size_bytes })),
                      budgetBytes,
                  ),
    };
}

// Null while the selection fits; otherwise the message the technician sees instead of a bare 422.
export function overBudgetMessage(overview: IQuoteAttachmentOverview): string | null {
    if (!overview.budget || overview.budget.within_budget) return null;
    const listing = overview.onMail
        .map(document => `${document.label} (${formatBytes(document.size_bytes)})`)
        .join(', ');
    return (
        `Bijlages ${formatBytes(overview.budget.total_bytes)} overschrijden het mailbudget van ` +
        `${formatBytes(overview.budget.budget_bytes)}: ${listing}`
    );
}
